export default "__VITE_ASSET__DsM_QkKh__"